import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DayCalendar from './DayCalendar';
import api from '../services/api';
import { useAuth } from '../contexts/AuthContext';

export default function ProfilePage() {
  const { id } = useParams();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        // Get the viewed profile
        const { data: userData } = await api.get(`users/${id}/`);
        setUser(userData);
        setLoading(false);
      } catch (err) {
        console.error('Failed to load profile:', err);
        setError('Could not load user profile');
        setLoading(false);
      }
    };
    
    fetchData();
  }, [id]);

  if (loading) return <p>Loading profile...</p>;
  if (error) return <p style={{color: 'red'}}>{error}</p>;
  if (!user) return <p>User not found</p>;

  // Check if current user is viewing their own profile
  const isOwnProfile = currentUser && currentUser.id === user.id;

  return (
    <div style={{ padding: '1rem' }}>
      <h2>{user.display_name || user.username}'s Grades</h2>
      
      {isOwnProfile && (
        <div style={{ marginBottom: '1rem' }}>
          <Link to="/settings" style={{ 
            backgroundColor: '#4CAF50', 
            color: 'white', 
            padding: '10px 15px',
            textDecoration: 'none',
            borderRadius: '4px',
            marginRight: '1rem'
          }}>
            Edit Profile
          </Link>
          <span style={{ fontSize: '0.9rem' }}>
            Profile is {user.is_public ? 'Public' : 'Private'}
          </span>
        </div>
      )}
      
      <DayCalendar 
        userId={id} 
        initialView="monthly"
        readOnly={!isOwnProfile} // Only allow editing if own profile
      />
    </div>
  );
}